<template>
  <b-modal
    id="chooseCorrectPasteModal"
    size="lg"
    title="Уточнение добавляемой информации"
    @ok="onSave"
  >
    <div v-if="incorrectData">
      <b-form-group
        v-if="incorrectData.direction"
        :label="`Направление ${localData.direction.current}`"
      >
        <MultiSelect
          :value="localData.direction.correct"
          :options="directions"
          label="codeTitle"
          @input="onSelectDirection"
        />
      </b-form-group>
      <b-form-group
        v-for="(exam, index) of localData.exams"
        :key="index"
        :label="`Предмет ${exam.current}`"
      >
        <MultiSelect
          :value="exam.correct"
          :options="exams"
          label="name"
          @input="(data) => onSelectSubject(data, index)"
        />
      </b-form-group>
      <b-form-group
        v-for="(olympiad, index) of localData.olympiads"
        :key="index"
        :label="`Олимпиада ${olympiad.current}`"
      >
        <MultiSelect
          :value="olympiad.correct"
          :options="olympiads"
          label="title"
          @input="(data) => onSelectOlympiad(data, index)"
        />
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isNotAllFill">
        Сохранить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import MultiSelect from '@/components/ui/MultiSelect.vue'

export default {
  name: 'ChooseCorrectPasteModal',
  components: {
    MultiSelect
  },
  props: {
    incorrectData: {
      type: Object,
      default() {
        return null
      }
    },
    olympiads: {
      type: Array,
      default() {
        return []
      }
    },
    exams: {
      type: Array,
      default() {
        return []
      }
    },
    directions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    incorrectData: {
      deep: true,
      handler() {
        this.localData = this.incorrectData
      }
    }
  },
  data() {
    return {
      localData: {
        direction: null,
        olympiads: [],
        exams: []
      }
    }
  },
  computed: {
    isNotAllFill() {
      return !!((this.incorrectData.direction && !this.incorrectData.direction.correct)
        || (this.incorrectData.olympiads && this.incorrectData.olympiads.find((ol) => !ol.correct))
        || (this.incorrectData.exams && this.incorrectData.exams.find((ex) => !ex.correct)))
    }
  },
  methods: {
    onSelectDirection(obj) {
      this.localData.direction.correct = obj ? [obj] : null
    },
    onSelectSubject(obj, index) {
      this.localData.exams[index].correct = obj ? [obj] : null
    },
    onSelectOlympiad(obj, index) {
      this.localData.olympiads[index].correct = obj ? [obj] : null
    },
    onSave() {
      this.$emit('save', this.localData)
    }
  }
}
</script>

<style scoped>

</style>
